/**
 * 获取自动滚动的距离
 * @param el 当前项
 * @param container 父容器
 * @param defDistance 默认滚动距离
 * @param defOffset 默认靠边距离
 * @returns
 */
export function getAutoScrollDistance(el: HTMLElement, container: HTMLElement, defDistance = 120, defOffset = 40) {
  const { right, left } = el.getBoundingClientRect();
  const { right: parentRight, left: parentLeft } = container.getBoundingClientRect();
  // 计算移动距离
  let distance = 0;
  // 当点击靠右边的分类项时，需要将整个分类列表做左移动
  if (right + defOffset >= parentRight) {
    distance = defDistance;
  } else if (left <= parentLeft + defOffset) {
    // 当点击最左边的分类时，需要将整个分类列表做右移动
    distance = -defDistance;
  }
  return distance;
}

/**
 * 滚动条状态
 */
export enum ScrollerState {
  /** 最左 */
  start = 1,
  /** 最右 */
  end,
  /** 其他 */
  other
}

/**
 * 计算统计滚动状态
 * @param container 滚动容器元素
 * @returns
 */
export function getScrollState(container: HTMLElement) {
  const defOffset = 10;
  const { scrollWidth, scrollLeft, offsetWidth } = container;
  const isAtStart = scrollLeft < defOffset;
  const isAtEnd = scrollWidth - scrollLeft - offsetWidth < defOffset;
  if (isAtStart) {
    return ScrollerState.start;
  }
  if (isAtEnd) {
    return ScrollerState.end;
  }
  return ScrollerState.other;
}
